import { FilterListOff, FilterListOutlined, Launch } from '@mui/icons-material';
import {
  IconButton,
  ListItemIcon,
  MenuItem,
  Typography,
  Menu,
} from '@mui/material';
import { usePopupState } from 'material-ui-popup-state/hooks';
import {
  bindHover,
  bindPopover,
  bindMenu,
  bindTrigger,
} from 'material-ui-popup-state';
import { useTranslation } from 'react-i18next';
import HoverPopover from 'material-ui-popup-state/HoverPopover';

type SearchFilterButtonDropdownProps = {
  toggle: () => void;
  reset: () => void;
};

const SearchFilterButtonDropdown = ({
  toggle,
  reset,
}: SearchFilterButtonDropdownProps) => {
  const { t } = useTranslation();

  const menuPopupState = usePopupState({
    variant: 'popover',
    popupId: 'search-filter-popup-menu',
  });
  const popoverPopupState = usePopupState({
    variant: 'popover',
    popupId: 'search-filter-popup-popover',
  });

  const handleClearFilters = () => {
    reset();
    menuPopupState.close();
  };

  const handleShowFilters = () => {
    toggle();
    menuPopupState.close();
  };

  return (
    <>
      <IconButton
        {...bindTrigger(menuPopupState)}
        {...bindHover(popoverPopupState)}
        sx={{
          mb: -1,
          mt: -1,
        }}
      >
        <FilterListOutlined color="secondary" />
      </IconButton>
      <HoverPopover
        sx={{
          pointerEvents: 'none',
          mt: 1,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        {...bindPopover(popoverPopupState)}
      >
        <Typography sx={{ p: 1 }}>
          {t('SearchDataGrid.filters.filterButtonDropdown.popoverContent')}
        </Typography>
      </HoverPopover>
      <Menu {...bindMenu(menuPopupState)}>
        <MenuItem onClick={handleClearFilters} data-testid="Clear.FilterOption">
          <ListItemIcon sx={{ mr: 0 }}>
            <FilterListOff fontSize="small" />
          </ListItemIcon>
          {t('SearchDataGrid.filters.filterButtonDropdown.clearFilterOption')}
        </MenuItem>
        <MenuItem onClick={handleShowFilters} data-testid="Show.FilterOption">
          <ListItemIcon sx={{ mr: 0 }}>
            <Launch fontSize="small" />
          </ListItemIcon>
          {t('SearchDataGrid.filters.filterButtonDropdown.showFilterOption')}
        </MenuItem>
      </Menu>
    </>
  );
};

export default SearchFilterButtonDropdown;
